export enum SearchOrder {
  Relevance = 'Relevance',
  PerformerNameAsc = 'PerformerNameAsc',
  PerformerNameDesc = 'PerformerNameDesc',
  PrimaryAgentNameAsc = 'PrimaryAgentNameAsc',
  PrimaryAgentNameDesc = 'PrimaryAgentNameDesc',
  PlayingAgeFromAsc = 'PlayingAgeFromAsc',
  PlayingAgeFromDesc = 'PlayingAgeFromDesc',
}
